import { render } from "./roleCard.vue?vue&type=template&id=5b7bccb1&scoped=true"
import script from "./roleCard.vue?vue&type=script&lang=js"
export * from "./roleCard.vue?vue&type=script&lang=js"

import "./roleCard.vue?vue&type=style&index=0&id=5b7bccb1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7bccb1"]])

export default __exports__